import LedgerReportPresenter from "@adapters/presenters/Reports/LedgerReport";
export default (useCases, actions) => {
    return {
        marginReport: new LedgerReportPresenter(actions, useCases, useCases.sendEmailReports, useCases.downloadPDFReports, useCases.downloadExcelReports, useCases.commonUsecase),
    };
};
